import i18n from "../i18n/i18n";

export const formatDate = (dateString, fallback = "N/A") => {
  if (dateString === null || dateString === undefined || dateString === "") {
    return fallback;
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return fallback;
  }

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  hours = hours % 12 || 12;
  hours = hours.toString().padStart(2, "0");

  return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
};

const formatCalendarParts = (year, monthIndex, day, locale) => {
  const date = new Date(year, monthIndex, day);
  if (isNaN(date.getTime())) {
    return null;
  }

  const paddedDay = day.toString().padStart(2, "0");
  const month = date.toLocaleString(locale, { month: "short" });
  return `${paddedDay} ${month} ${year}`;
};

export const formatDateOnly = (dateString, fallback = "N/A") => {
  if (dateString === null || dateString === undefined || dateString === "") {
    return fallback;
  }

  const locale = i18n.language || "en-GB";
  const bareDateMatch = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (bareDateMatch) {
    const year = Number(bareDateMatch[1]);
    const monthIndex = Number(bareDateMatch[2]) - 1;
    const day = Number(bareDateMatch[3]);
    return (
      formatCalendarParts(year, monthIndex, day, locale) || fallback
    );
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return fallback;
  }

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString(locale, {
    month: "short",
  });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};
